var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audioRef",attrs:{"controls":"","autoplay":"","hidden":""}},[_c('source',{attrs:{"src":require("@/assets/sounds/s08.mp3"),"type":"audio/mpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }